module.exports = __webpack_public_path__ + "img/twitter.fedc63aa.svg";